
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookFallAnimalExtension",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "",
      apiSaveMethod: "api/sync/syncWildbook",
      form: "WildbuchEintragFallwild",
      page: "WildbuchEintragTierartZusatzFallwild",
      remoteId: "",
      

      

    });
    return {
      request
    };
  }
};
